<template>
  <div class="child-profile">
    <avatar-profile-picture :childId="childId" />
  </div>
</template>

<script>
  import AvatarProfilePicture from '@/components/Child/ChildAvatarProfilePicture/ChildSettings'
0
  export default {
    components: {
      AvatarProfilePicture
    },

    props: {
      childId: {
        type: String,
        required: true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .child-profile {
    width: 100%;
    height: auto;

    padding: calc(#{$header-height} + 30px) 20px 10px 20px;
  }
</style>